import { axiosInstance } from './axiosInstance';

export const getCompany = async () => {
  return axiosInstance.get('/company');
};
